<script>
import getSecret from "@utils/get-secret";
import vueFabric from '@components/utils/Fabric';
import JsBarcode from 'jsbarcode';
import { manageStoreMethods } from "@state/helpers";
import vueJsonEditor from 'vue-json-editor'


export default {
    name: 'LabelCanvasThumbnail',
    props: {
        selectedTag: {
            type: Object,
            required: false,
            default: () => {},
        },
        itemInfo: {
            type: Object,
            required: true
        },
    },
    components: { 
        vueFabric,
        vueJsonEditor
    },
    data() {
        return {
            templateRendered: false,
            canvasUrl: null,
            reference: {},
            templates: [],
            usedVariables: [],
            activeCanvas: {},
            canvasReady: false,
            inputJSON: {},
            canvasScale: 0.2,
            newBarcode: '',
            showJsonEditor: false,
            canvasObjectObjectFontFamily: "",
            templateTranslations: {},
            fontFamilies: [
                { value: "Andale Mono", text: "Andale Mono" },
                { value: "Arial Black", text: "Arial Black" },
                { value: "Arial", text: "Arial" },
                { value: "Comic Sans MS", text: "Comic Sans MS" },
                { value: "Courier New", text: "Courier New" },
                { value: "Georgia", text: "Georgia" },
                { value: "Impact", text: "Impact" },
                { value: "Times New Roman", text: "Times New Roman" },
                { value: "Trebuchet", text: "Trebuchet" },
                { value: "Verdana", text: "Verdana" },
            ],
            selectedInsertImageUrl: null,
            insertImageGallery: [],
        }
    },
    methods: {
        ...manageStoreMethods,
        
        async mixTemplateData(obj){
            let result = null
            if (obj.type === 'textbox' && obj.metadata && obj.metadata.substring(0, 3) == "%t."){
                this.usedVariables.push(obj.metadata.replace(':',''))
                for (const [key, value] of Object.entries(this.templateTranslations)){
                    if (key == (obj.metadata).substring(3).replace(":","")){
                        obj.text = value.toString();
                        result = 'text'
                    }
                }
            } else if (obj.type === 'textbox' && obj.metadata && obj.metadata.substring(0, 1) === '$'){
                this.usedVariables.push(obj.metadata)
                let _item_info = Object.keys(this.itemInfo).length > 0 ? this.itemInfo[obj.metadata.replace('$','')] : obj.metadata
                if (!_item_info || this.itemInfo[obj.metadata.replace('$','')] === ''){
                    _item_info = obj.metadata
                    result = 'text';
                }  
                if (obj.metadata.indexOf('$price') > -1){
                    try {
                        _item_info = `\$${_item_info.toLocaleString('ES-es', {useGrouping: true})}`
                    } catch {
                        _item_info = obj.metadata
                    }
                } 
                obj.text = `${_item_info}`
                result = 'text'
            } else if (obj.type === 'image' && obj.metadata && obj.metadata.substring(0, 1) === '$'){
                let _item_info = Object.keys(this.itemInfo).length > 0 ? this.itemInfo[obj.metadata.replace('$','')] : obj.metadata
                obj.src = this.getBarcode(_item_info)
                result = 'barcode'
            } else {
                result = null
            }
            return { obj , result }
        },
        async renderTemplate(template={name:''}){
            if (!template.id && template.name !== '') { // cuando no es un tag, sino un template (temporal)
                this.selectedTag.template = template.name
                this.selectedTag.reference_id = template.reference
            }
            this.activeCanvas = this.$refs[`label-${this.selectedTag.reference_id}`];
            this.activeCanvas.clear();
            this.canvasReady = null
            let SCALE = 0.5
            await this.fetchTemplate({ ref: this.selectedTag.reference_id, templateId: template.name || this.selectedTag.template })
            .then(async (json) => { 
                this.canvasReady = false
                this.inputJSON = json.data; 
                let this_ = this
                this.inputJSON.labelData.objects.forEach(async function(_obj){
                    _obj.selectable = false;
                    _obj.scaleX = _obj.scaleX * SCALE;
                    _obj.scaleY = _obj.scaleY * SCALE;
                    _obj.left = _obj.left * SCALE;
                    _obj.top = _obj.top * SCALE;
                    let { obj, result } = await this_.mixTemplateData(_obj);
                    if (result){
                        if (result === 'barcode'){
                            obj.src = this_.activeCanvas.renderAll.bind(this_.activeCanvas)
                        }
                        _obj = obj
                    }
                });
                await this.activeCanvas.loadFromJSON2(this.inputJSON.labelData)
                this.activeCanvas.canvas.setWidth(this.activeCanvas.width * SCALE)
                this.activeCanvas.canvas.setHeight(this.activeCanvas.height * SCALE)
                this.activeCanvas.renderAll();
            }).catch((e) => { 
                console.error("Error:", e);
            });
        },
        loadLocalJSON(URL){
            fetch(URL).then(async (response) => {
                if (!response.ok) {
                    throw new Error('No se pudo cargar el archivo JSON.');
                }
                this.templateTranslations = await response.json();
            })
            .catch((error) => {
                return {};
            });
        },
        refreshJson(){
            this.inputJSON.labelData = this.activeCanvas.toJson()
        },
        getBarcode(barcode='1234567890'){
            const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.setAttribute("width", 120);
            svg.setAttribute("height", 50);
            
            JsBarcode(svg, barcode, {
                format: 'CODE128',
                displayValue: false,
                width: 2,
                height: 50,
                margin: 4,
            });
            let barcodeImage = new XMLSerializer().serializeToString(svg);
            let data = 'data:image/svg+xml,' + encodeURIComponent(barcodeImage)
            // console.log("generando: ", barcode, data)
            return data
        },
    },
    beforeMount() {
        let this_ = this
        this.fetchReferences().then((response) => {
            this_.reference = response.data.results.find(x => x.id === this_.selectedTag.reference_id);
        }),
        this.fetchTemplates().then((response) => {
            this.templates = _.cloneDeep(response.data.results);
        })
        // TODO: TO CACHE!!!!
        this.loadLocalJSON(`http://192.168.1.37:3000/templates/languages/es.json`);
    },
    mounted(){
        
        this.$nextTick(() => {
            if (this.$refs[`label-${this.selectedTag.reference_id}`] && !this.templateRendered){
                this.renderTemplate();
                this.templateRendered = true
            }
        });
    },

    updated(){
        this.$nextTick(() => {
            if (this.$refs[`label-${this.selectedTag.reference_id}`] && !this.templateRendered){
                this.renderTemplate();
                this.templateRendered = true
            }
        });
    }
}
</script>



<template>
    <div>
        <vue-fabric 
            v-if="Object.keys(reference).length > 0"
            :ref="`label-${reference.id}`" 
            :id="`canvas-${reference.id}-${selectedTag._id}-${selectedTag.template}`" 
            class="canvas-thumbnail"
            :data-ref="reference.id"
            :width="reference.screen_width" 
            :height="reference.screen_height"
            >
        </vue-fabric>
    </div>
</template>

<style lang="scss" scoped>
$gray-200: #DCDCDC;
.canvas-thumbnail {
    border: 1px solid #d4d4d4;
}
</style>